import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api/notification",
  headers: {
    "Content-Type": "application/json",
  },
});

const sendBespokeHFNotification = async (data) => {
  return apiClient.post("/send/bespokehf", data);
};

const sendSpeakToConsultantNotification = async (data) => {
  return apiClient.post("/send/speaktoconsultant", data);
};

const sendNoProductConsultantNotification = async (data) => {
  return apiClient.post("/send/speaktoconsultantnoproduct", data);
};

const sendReviewNotification = async (data) => {
  return apiClient.post("/send/sendreview", data);
};

const sendDontKnowWhatIWantNotification = async (data) => {
  return apiClient.post("/send/idontknowwhatiwant", data);
};

export const notificationService = {
  sendBespokeHFNotification,
  sendSpeakToConsultantNotification,
  sendNoProductConsultantNotification,
  sendReviewNotification,
  sendDontKnowWhatIWantNotification,
};
